import {IElement, ITextAttributes} from 'routes/private/Editor/types';
import { updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontAlignmentResolver = ( element: IElement, value: string ):IElement => {
    if (element.type === "Text") {
        (element.attributes as ITextAttributes).textAlign = value;    
        element.attributes = updateRenderingTextSegments(element.attributes as ITextAttributes);
    }
    return element;
}